import { CloudDownload } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

import { Link } from '@/containers';
import { EpisodeResource } from '@/types';

const FILE_EXTENSION_REGEX = /\.\w+$/;

export const EpisodeResources = ({
  resources,
  onResourceClick,
  contrast = 'dark',
}: {
  resources: EpisodeResource[];
  onResourceClick: (resource: EpisodeResource) => void;
  contrast?: 'light' | 'dark';
}) => {
  const formattedResources = [...resources]
    .sort((a, b) => {
      if (a.name.includes('Episode Transcript')) return -1;
      if (b.name.includes('Episode Transcript')) return 1;
      return a.name.localeCompare(b.name);
    })
    .map(resource => ({
      ...resource,
      extension: resource.file.url.match(FILE_EXTENSION_REGEX)?.[0],
    }));
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {formattedResources.length > 0 &&
        formattedResources.map((resource, index) => (
          <Box
            key={index}
            sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {resource.extension ? (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'text.contrast',
                  backgroundColor: 'secondary.main',
                  width: 24,
                  height: 24,
                  borderRadius: 1,
                  flexShrink: 0,
                }}>
                <Typography
                  variant="caption2Bold"
                  sx={{ color: 'text.contrast' }}>
                  {resource.extension}
                </Typography>
              </Box>
            ) : (
              <CloudDownload />
            )}
            <Link
              onClick={() => onResourceClick(resource)}
              color={contrast === 'dark' ? 'text.contrast' : 'secondary.main'}>
              {resource.name}
            </Link>
          </Box>
        ))}
    </Box>
  );
};
